module.exports = __webpack_public_path__ + "img/387040.c53ef6da.svg";